export var GamePhase;
(function (GamePhase) {
    GamePhase["Lobby"] = "lobby";
    GamePhase["Setup"] = "setup";
    GamePhase["GhostMeeting"] = "ghost_meeting";
    GamePhase["ClueGiving"] = "clue_giving";
    GamePhase["Discussion"] = "discussion";
    GamePhase["RoleReveal"] = "role_reveal";
    GamePhase["GhostGuessing"] = "ghost_guessing";
    GamePhase["GuessReveal"] = "guess_reveal";
    GamePhase["GameEnd"] = "game_end";
})(GamePhase || (GamePhase = {}));
//# sourceMappingURL=phases.js.map